<template>
  <div class="row">
    <div class="columns" :class="['columns-' + curRow.name]" :style="animStyle">
      <div class="column"></div>
      <div class="column"></div>
      <div class="column"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    Row: {
      name: "",
      index: 0,
      value: 0,
      endValue: 0,
      speed: 200,
      isRunning: false,
      key: Math.random(),
      direction: "",
    },
  },
  data() {
    return {
      animStyle: [],
      curRow: this.Row,
      inter: undefined,
    };
  },
  name: "HelloWorld",
  mounted() {
    this.animStyle = {
      "animation-name": `${this.curRow.direction}-transition-${this.curRow.value}`,
      "animation-duration": `${this.curRow.speed}ms`,
    };
    console.log(
      "this.animStylethis.animStylethis.animStylethis.animStyle",
      this.animStyle
    );
    this.startInterval();
  },
  methods: {
    startInterval() {
      this.inter = setInterval(() => {
        if (
          this.curRow.isRunning &&
          (this.curRow.direction == "ltr" || this.curRow.direction == "rtl")
        ) {
          let value =
            this.curRow.direction == "ltr"
              ? this.curRow.value < 2
                ? this.curRow.value + 1
                : 0
              : this.curRow.value > 0
              ? this.curRow.value - 1
              : 2;

          this.animStyle = {
            "animation-name": `${this.curRow.direction}-transition-${this.curRow.value}`,
            "animation-duration": `${this.curRow.speed}ms`,
          };
          this.curRow.value = value;
        }
      }, 100);
    },

    clearRowInterval() {
      console.log("暂停");
      clearInterval(this.inter);
    },
    gundong() {},
  },
};
</script>

<style>
.columns {
  background-color: #fdcbc4;
  background-size: 100% 100%;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
.columns.columns-top {
  background-image: url("../assets/img/1.png");
}
.columns.columns-center {
  background-image: url("../assets/img/2.png");
}
.columns.columns-bottom {
  background-image: url("../assets/img/3.png");
}
.columns:after {
  content: "";
  display: block;
  padding-top: 12.07%;
}

@-webkit-keyframes ltr-transition-0 {
  0% {
    background-position: 0vw;
  }
  100% {
    background-position: 33.3333vw;
  }
}

@keyframes ltr-transition-0 {
  0% {
    background-position: 0vw;
  }
  100% {
    background-position: 33.3333vw;
  }
}
@-webkit-keyframes ltr-transition-1 {
  0% {
    background-position: 33.3333vw;
  }
  100% {
    background-position: 66.6666vw;
  }
}
@keyframes ltr-transition-1 {
  0% {
    background-position: 33.3333vw;
  }
  100% {
    background-position: 66.6666vw;
  }
}
@-webkit-keyframes ltr-transition-2 {
  0% {
    background-position: 66.6666vw;
  }
  100% {
    background-position: 100vw;
  }
}
@keyframes ltr-transition-2 {
  0% {
    background-position: 66.6666vw;
  }
  100% {
    background-position: 100vw;
  }
}
@-webkit-keyframes rtl-transition-0 {
  0% {
    background-position: -33.3333vw;
  }
  100% {
    background-position: -66.6666vw;
  }
}
@keyframes rtl-transition-0 {
  0% {
    background-position: -33.3333vw;
  }
  100% {
    background-position: -66.6666vw;
  }
}
@-webkit-keyframes rtl-transition-1 {
  0% {
    background-position: -100vw;
  }
  100% {
    background-position: -133.3333vw;
  }
}
@keyframes rtl-transition-1 {
  0% {
    background-position: -100vw;
  }
  100% {
    background-position: -133.3333vw;
  }
}
@-webkit-keyframes rtl-transition-2 {
  0% {
    background-position: -166.6666vw;
  }
  100% {
    background-position: -200vw;
  }
}
@keyframes rtl-transition-2 {
  0% {
    background-position: -166.6666vw;
  }
  100% {
    background-position: -200vw;
  }
}
</style>
